import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

const AlertOverlay = ({
  defaultAlertMessage,
  registrosDuplicados = [],
  registrosErrados = [],
  onClose
}) => {
  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <p className="ficha-secciones-title-text font-gothan-light">
          <FontAwesomeIcon icon='info-circle' transform="left-9" className="hand-pointer"/>&nbsp;&nbsp;&nbsp; {defaultAlertMessage}
        </p>
        {registrosDuplicados.length > 0 && (
          <>
            <strong>Registros duplicados:</strong>
            <ul>
              {registrosDuplicados.map((id, index) => (
                <li key={`dup-${index}`}>{id}</li>
              ))}
            </ul>
          </>
        )}
        {registrosErrados.length > 0 && (
          <>
            <strong>Registros con errores:</strong>
            <ul>
              {registrosErrados.map((id, index) => (
                <li key={`err-${index}`}>{id}</li>
              ))}
            </ul>
          </>
        )}

        <button style={styles.button} onClick={onClose}>
          Continuar
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    zIndex: 9999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    background: "#fff",
    borderRadius: "10px",
    padding: "20px",
    width: "600px",
    maxHeight: "80vh",
    overflowY: "auto",
    textAlign: "left",
  },
  button: {
    marginTop: "20px",
    display: "block",
    marginLeft: "auto",
    padding: "10px 24px",
    background: "#007bff",
    border: "none",
    borderRadius: "5px",
    color: "white",
    cursor: "pointer",
  },
};

export default AlertOverlay;
